// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/taf-wind-visibility-decode.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/taf-wind-visibility-decode/taf-wind-visibility-decode.js';

mount([g0]);
